<template>
  <span
    class="button-field-action-cost"
    :title="$t('buttonFieldActionCost.title')"
  >
    {{ $t('buttonFieldActionCost.flat', { count: units }) }}
  </span>
</template>

<script>
// Mirrors `DEFAULT_COST_TYPE` in the backend's `automation_cost_types.py`.
// `WORKFLOW_ACTION_COST_OVERRIDES` is empty, so every action the plugin shows
// this on costs the same.
const UNITS = 1

export default {
  name: 'ButtonFieldActionCost',
  props: {
    workspace: {
      type: Object,
      required: false,
      default: null,
    },
    actionType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { units: UNITS }
  },
}
</script>
